import React from 'react';
import flowers from '../img/flowers2.png';
import ornament from '../img/ornament.png';

const hotels = [
  {
    image: '/img/hotel_nirvana.png',
    name: 'Hotel Nirvana',
    address: 'Camino Antigua Via del Ferrocarril 21, San Miguel de Allende',
    phone: '415 185 2194',
    mapLink: 'https://maps.app.goo.gl/srJw2GqfGDbKUz1r8', // Replace with the actual location link
  },
  {
    image: '/img/hotel_casa_de_aves.jpg',
    name: 'Hotel Casa de Aves',
    address: 'Rancho Los Fresnos 1, San Miguel de Allende',
    phone: '415 488 6104',
    mapLink: 'https://maps.app.goo.gl/4PbhsY9b7HZCHkYE7', // Replace with the actual location link
  },
  {
    image: '/img/hotel_tierra_y_amor.jpg',
    name: 'Tierra y Amor',
    address:
      'Ctra. San Miguel de Allende-Dolores Hidalgo Km13.5, San Miguel de Allende',
    phone: '415 153 5986',
    mapLink: 'https://maps.app.goo.gl/QYN3Tnfb7GezKf5HA', // Replace with the actual location link
  },
];

const HospedajeSection: React.FC = () => {
  return (
    <section id="hospedaje" className="bg-[#F7F4EF] text-center p-8 pb-0">
      {/* Title */}
      <h2 className="text-title text-[#B94665]">HOSPEDAJE</h2>

      {/* Separator */}
      <div className="mt-4">
        <img
          src={ornament}
          alt="Ornament"
          className="mx-auto transform scale-x-[1] ornament-size h-auto "
        />
      </div>

      {/* Subtitle */}
      <p className="mt-8 text-lg italic text-gray-500">
        Aquí te compartimos algunas opciones de hospedaje.
      </p>

      {/* Hotel Cards Grid */}
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {hotels.map((hotel, index) => (
          <div
            key={index}
            className="rounded-lg shadow-md overflow-hidden bg-white"
          >
            {/* Hotel Image */}
            <img
              src={hotel.image}
              alt={hotel.name}
              className="w-full h-48 object-cover"
            />

            {/* Hotel Details */}
            <div className="p-6">
              <h3 className="text-lg text-[#B94665]">{hotel.name}</h3>
              <p className="mt-2 text-sm text-gray-500">{hotel.address}</p>
              <p className="mt-1 text-sm text-gray-500">{hotel.phone}</p>

              {/* View Location Link */}
              <a
                href={hotel.mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-block text-[#B94665] font-medium underline hover:text-[#9c3b57] transition"
              >
                Ver Ubicación
              </a>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12">
        <img
          src={flowers}
          alt="Decorative Flowers"
          className="mx-auto transform scale-y-[-1]"
        />
      </div>
    </section>
  );
};

export default HospedajeSection;
